import { call, put } from 'redux-saga/effects'

const identity = (value) => value

const buildError = (result) => ({
    status: 'failed',
    error: result,
})

export function buildApiSaga ({
    request,
    action,
    mapPayload = identity,
    mapResult = identity,
    mapError = identity,
}) {
    return function * ({ type, ...payload }) {
        try {
            const result = yield call(request, mapPayload(payload))

            if (result && result.error) {
                // Application errors, including 4xx, 5xx
                yield put(action(mapResult(result.result), mapError(buildError(result.error), payload)))
                return
            }

            // Happy path
            if (result) {
                yield put(action(mapResult(result.result)))
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error)
            // Runtime or network errors
            yield put(action(mapResult(), mapError(buildError(error.message), payload)))
        }
    }
}
